import nationalities from '../data/nationalities.json';

const COUNTRY_ALIASES = {
    'united states of america': 'United States',
    'russia': 'Russia',
    'russian federation': 'Russia',
    'vietnam': 'Vietnam',
    'viet nam': 'Vietnam',
    'syria': 'Syria',
    'syrian arab republic': 'Syria',
    'iran': 'Iran',
    'iran islamic republic of': 'Iran',
    'south korea': 'South Korea',
    'korea republic of': 'South Korea',
    'north korea': 'North Korea',
    'korea democratic people s republic of': 'North Korea',
    'laos': 'Laos',
    'lao people s democratic republic': 'Laos',
    'moldova': 'Moldova',
    'moldova republic of': 'Moldova',
    'tanzania': 'Tanzania',
    'tanzania united republic of': 'Tanzania',
    'brunei': 'Brunei',
    'brunei darussalam': 'Brunei',
    'ivory coast': 'Ivory Coast',
    'cote d ivoire': 'Ivory Coast',
    'czechia': 'Czechia',
    'czech republic': 'Czechia',
    'vatican': 'Vatican City',
    'holy see vatican city state': 'Vatican City',
    'palestine': 'Palestine',
    'palestinian territory occupied': 'Palestine',
    'macao': 'Macau',
    'macau': 'Macau',
    'swaziland': 'Eswatini',
    'dubai': 'United Arab Emirates',
    'virgin islands british': 'British Virgin Islands',
    'virgin islands u s': 'United States Virgin Islands',
    'aland islands': 'Åland Islands',
    'congo': 'Republic of the Congo',
    'congo democratic republic of the congo': 'DR Congo',
    'taiwan province of china': 'Taiwan',
    'libyan arab jamahiriya': 'Libya',
    'macedonia the former yugoslav republic of': 'Macedonia',
    'micronesia federated states of': 'Micronesia',
    'reunion': 'Réunion',
    'curacao': 'Curaçao',
    'falkland islands malvinas': 'Falkland Islands',
    'heard island and mcdonald islands': 'Heard Island and McDonald Islands',
    'pitcairn': 'Pitcairn Islands',
    'serbia and montenegro': 'Serbia',
    'south georgia and the south sandwich islands': 'South Georgia',
    'netherlands antilles': 'Netherlands',
};

function normalizeCountryKey(value) {
    return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
}

function isUnset(value) {
    return value === undefined || value === null || value === '' || value === '0' || value === 0;
}

/** True when the user picked a real country (not the placeholder "0"). */
export function isCountrySelected(country) {
    return !isUnset(country);
}

export function getManatalCountryNames() {
    const names = nationalities
        .map((n) => n.common_name)
        .filter(Boolean);
    return [...new Set(names)].sort((a, b) => a.localeCompare(b));
}

/**
 * Resolve a stored/DB country to a Manatal option value.
 * Either returns the exact Manatal name if already valid, or a mapped fallback.
 */
export function resolveCountryForSelect(country) {
    if (isUnset(country)) return '0';

    const names = getManatalCountryNames();
    if (names.includes(country)) return country;

    const byNorm = new Map(names.map((n) => [normalizeCountryKey(n), n]));
    const key = normalizeCountryKey(country);

    if (byNorm.has(key)) return byNorm.get(key);

    const aliased = COUNTRY_ALIASES[key];
    if (aliased) {
        const aliasedKey = normalizeCountryKey(aliased);
        if (byNorm.has(aliasedKey)) return byNorm.get(aliasedKey);
        if (names.includes(aliased)) return aliased;
    }

    const partial = names.find((n) => {
        const nKey = normalizeCountryKey(n);
        return nKey.includes(key) || key.includes(nKey);
    });
    if (partial) return partial;

    // Keep original so an unmatched legacy value can still be shown via extra option
    return country;
}
